// Select all of the case study sliders on the page and loop through them
const navToggle = document.querySelector('#toggleMainNavigation');
if(navToggle){
    navToggle.addEventListener('click', function (event) {
        let navigation = document.getElementById(this.getAttribute('aria-controls'));
        let body = document.querySelector('body');
        if(this.getAttribute('aria-expanded') == 'false') {
            navigation.classList.add('active');
            body.classList.add('noScroll');
            this.setAttribute('aria-expanded', 'true');
            this.setAttribute('aria-label', 'Close navigation');
        } else {
            let activeMenus = document.querySelectorAll('.header nav .active');
            let activeButtons = document.querySelectorAll('.header nav button[aria-expanded=true]');
            activeMenus.forEach(menu => {
                menu.classList.remove('active');
            });
            activeButtons.forEach(button => {
                button.setAttribute('aria-expanded', false);
            });
            body.classList.remove('noScroll');
            this.setAttribute('aria-expanded', false);
            this.setAttribute('aria-label', 'Open navigation');
        }
    });
}

const subMenuButtons = document.querySelectorAll('#mainNavigation .menu-item--expanded button');
subMenuButtons.forEach(button => {
    let subMenu = button.nextElementSibling;
    button.addEventListener('click', function (event) {
        let expanded = button.getAttribute('aria-expanded') === 'true' || false;
        subMenu.classList.toggle('active');
        button.setAttribute('aria-expanded', !expanded);
    });
});